export default __webpack_public_path__ + "static/b5-415948031bdded04910f77604bf85894.png";